module.exports = __webpack_public_path__ + "static/img/订@3x.f1d006a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/订@3x.png
// module id = ae/5
// module chunks = 192